module.exports = __webpack_public_path__ + "static/media/developer.b6974ee0.svg";